<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img_public/products/h5_banner01.webp" />
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit_box">
					<div class="tit">{{ $t('product.text1') }}</div>
					<div class="txt">{{ $t('product.text2') }}</div>
				</div>
				<div class="block_1_el" v-for="(value, index) in cateList" :key="index" @click="goProducts(value)">
					<img class="bg" :src="index % 2 == 0 ? require('@/assets/img_public/products/block01.webp') : require('@/assets/img_public/products/block02.webp') " />
					<div class="tit2">{{ value.title }}</div>
					<div class="h5_public_btn">{{ $t('product.text6') }}<van-icon name="arrow" size="16px" class="btn_icon" /></div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			cateList: [],
		}
	},
	created(){
		let that = this;
		that.cateList = JSON.parse(sessionStorage.getItem('navList'))[1].children.cate_list;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击产品
		goProducts(value) {
			let that = this;
			that.$router.push({ path: '/product-list.html', query: { cate_ids: value.id, } });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		padding: 40px 20px;
		.btn_box{
			text-align: center;
			padding-top: 40px;
		}
		.block_1_el{
			height: 280px;
			position: relative;
			margin: 20px 0 0px 0;
			padding: 30px 20px;
			.h5_public_btn{
				position: absolute;
				bottom: 35px;
			}
			.bg{
				width: 100%;
				height: 100%;
				position: absolute;
				left: 0;
				top: 0;
				z-index: -1;
				background-size: cover;
			}
			.list_box{
				padding: 20px 0 30px 0;
				.list_el{
					display: inline-block;
					margin: 0 20px 8px 0;
					font-size: 16px;
					cursor: pointer;
				}
			}
			.tit2{
				font-size: 24px;
				font-weight: bold;
			}
			.tit1{
				font-size: 20px;
				color: #A20073;
				opacity: 0.1;
			}
		}
		.tit_box{
			.txt{
				padding-top: 8px;
				font-size: 16px;
			}
			.tit{
				font-size: 24px;
			}
		}
	}
	//轮播
	.banner_box{
		img{
			width: 100%;
		}
	}
}
</style>